export interface Client {
  id: string;
  name: string;
  logo: string;
}

export const clients: Client[] = [
  {
    id: 'sebrae',
    name: 'Sebrae',
    logo: '/images/logos/SebraeLogo.png',
  },
  {
    id: 'facerj',
    name: 'Facerj',
    logo: '/images/logos/FacerjLogo.png',
  },
  {
    id: 'bazar opção',
    name: 'Bazar Opção',
    logo: '/images/logos/BazarOpcaoLogo.png',
  },
  {
    id: 'convention bureau',
    name: 'Convention Bureau',
    logo: '/images/logos/ConventionLogo.png',
  },
];
